export default __webpack_public_path__ + "static/media/road safety.6c75eabd.jpg";